module.exports = __webpack_public_path__ + "static/media/rajan-exp-icon.c24bb151.png";